import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 28 28',
    fill: 'currentColor',
    defaultAriaLabel: 'Lock Icon',
};

export const LockCviIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                d="M12 18C12 16.8954 12.8954 16 14 16C15.1046 16 16 16.8954 16 18C16 18.7403 15.5978 19.3866 15 19.7324V21C15 21.5523 14.5523 22 14 22C13.4477 22 13 21.5523 13 21V19.7324C12.4022 19.3866 12 18.7403 12 18Z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22 11H24C25.1046 11 26 11.8954 26 13V25C26 26.1046 25.1046 27 24 27H4C2.89543 27 2 26.1046 2 25V13C2 11.8954 2.89543 11 4 11H6L6 8.4C6 4.63958 9.83853 2 14 2C18.1615 2 22 4.63958 22 8.4V11ZM20 11V8.4C20 6.19575 17.5705 4 14 4C10.4295 4 8 6.19575 8 8.4L8 11H20ZM4 25V13L24 13V25H4Z"
            />
        </SvgIcon>
    );
};
